var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInventoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 20.5C41 31.8218 31.8218 41 20.5 41C9.17816 41 0 31.8218 0 20.5C0 9.17816 9.17816 0 20.5 0C31.8218 0 41 9.17816 41 20.5Z",
    fill: "#FEC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.25 16.6162L19.0653 21.7057C19.1603 21.7605 19.2598 21.8001 19.3611 21.8253V31.6962L10.8787 26.6763C10.489 26.4456 10.25 26.0264 10.25 25.5736V16.6162ZM30.7496 16.481V25.5737C30.7496 26.0265 30.5106 26.4457 30.1209 26.6763L21.6385 31.6962V21.7388C21.6592 21.7285 21.6797 21.7175 21.6999 21.7058L30.7496 16.481Z",
    fill: "#FEC53D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5269 14.146C10.6345 14.01 10.7704 13.8951 10.9289 13.8107L19.8976 9.03376C20.2741 8.83323 20.7258 8.83323 21.1023 9.03376L30.071 13.8107C30.1932 13.8758 30.3019 13.959 30.3947 14.056L20.5614 19.7332C20.4967 19.7705 20.4371 19.8132 20.3828 19.8605C20.3285 19.8132 20.2688 19.7705 20.2042 19.7332L10.5269 14.146Z",
    fill: "#FEC53D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryIcon);
export default __webpack_public_path__ + "static/media/InventoryIcon.71a58b5b6113bc6738e47e21f86598d1.svg";
export { ForwardRef as ReactComponent };